import { render, staticRenderFns } from "./KaiForm.vue?vue&type=template&id=1fd52b12&scoped=true&"
import script from "./KaiForm.vue?vue&type=script&lang=ts&"
export * from "./KaiForm.vue?vue&type=script&lang=ts&"
import style0 from "./KaiForm.vue?vue&type=style&index=0&id=1fd52b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd52b12",
  null
  
)

export default component.exports